import { ServiceConsts } from "./ServiceConsts";
import { LoginService } from "./LoginService";
import { ApiService } from "./ApiService";

export class SearchService {
    static async search(query, semantic, tenantId) {
        return ApiService.get(
            ServiceConsts.API_URL + `/${tenantId}/search`,
            `q=${encodeURIComponent(query)}&semantic=${semantic}`,
            2
        );
    }

    static async getSuggestions(query, count = 5) {
        let suggestionsResponse = await ApiService.get(
            ServiceConsts.API_URL + "/copilot/suggestions",
            `q=${encodeURIComponent(query)}`,
        );
        let suggestions = [];

        for (let i = 0; i < suggestionsResponse.length; i++) {
            
            if (i >= count) break;

            suggestions.push(suggestionsResponse[i]);
        }

        suggestions = suggestions.map((suggestion) => {
            return {
                ...suggestion,
                url: suggestion.urlPath,
            };
        });

        return suggestions;
    }
}
